import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { LanguageDto, TimezoneDto } from "../../dto";

@Injectable()
export class StaticCommonService {
  readonly languagesLoaded: Observable<LanguageDto[]> = of([
    { id: 1, code: "DE", name: "Deutsch" },
    { id: 2, code: "EN", name: "Englisch" },
  ]);
  readonly timezonesLoaded: Observable<TimezoneDto[]> = of([
    { timezoneId: 1, name: "GMT -12:00 hours", timeshift: -12 },
    { timezoneId: 2, name: "GMT -11:00 hours", timeshift: -11 },
    { timezoneId: 3, name: "GMT -10:00 hours (Hawaii)", timeshift: -10 },
    { timezoneId: 4, name: "GMT -9:00 hours (Alaska)", timeshift: -9 },
    { timezoneId: 5, name: "GMT -8:00 hours (Pacific Time; US and Canada)", timeshift: -8 },
    { timezoneId: 6, name: "GMT -7:00 hours (Arizona)", timeshift: -7 },
    { timezoneId: 7, name: "GMT -7:00 hours (Mountain Std Time; US & Canada)", timeshift: -7 },
    { timezoneId: 8, name: "GMT -6:00 hours (Central Time; US and Canada)", timeshift: -6 },
    { timezoneId: 9, name: "GMT -5:00 hours (Eastern Time; US and Canada)", timeshift: -5 },
    { timezoneId: 10, name: "GMT -4:00 hours (Atlantic Time; Canada)", timeshift: -4 },
    { timezoneId: 11, name: "GMT -3:00 hours", timeshift: -3 },
    { timezoneId: 12, name: "GMT -2:00 hours (Mid-Atlantic)", timeshift: -2 },
    { timezoneId: 13, name: "GMT -1:00 hours", timeshift: -1 },
    { timezoneId: 14, name: "GMT +1:00 hours (CET; Germany)", timeshift: 1 },
    { timezoneId: 15, name: "GMT +2:00 hours (EET)", timeshift: 2 },
    { timezoneId: 16, name: "GMT +3:00 hours (Moscow)", timeshift: 3 },
    { timezoneId: 17, name: "GMT +4:00 hours", timeshift: 4 },
    { timezoneId: 18, name: "GMT +5:00 hours", timeshift: 5 },
    { timezoneId: 19, name: "GMT +6:00 hours", timeshift: 6 },
    { timezoneId: 20, name: "GMT +7:00 hours (Bangkok, Jakarta)", timeshift: 7 },
    { timezoneId: 21, name: "GMT +8:00 hours (Singapore,West- Australia, China)", timeshift: 8 },
    { timezoneId: 22, name: "GMT +9:00 hours (Tokyo)", timeshift: 9 },
    { timezoneId: 23, name: "GMT +10:00 hours", timeshift: 10 },
    { timezoneId: 24, name: "GMT +11:00 hours", timeshift: 11 },
    { timezoneId: 25, name: "GMT +12:00 hours", timeshift: 12 },
    { timezoneId: 26, name: "GMT", timeshift: 0 },
    { timezoneId: 28, name: "GMT +0:00 hours ", timeshift: 0 },
  ]);

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  loadLanguages(): void {}
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  loadTimezones(): void {}
}
